import { render, staticRenderFns } from "./rate-limit-exceeded.vue?vue&type=template&id=5f6bc4b8&"
import script from "./rate-limit-exceeded.vue?vue&type=script&lang=ts&"
export * from "./rate-limit-exceeded.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports